// The one y-axis scale the allocation bar charts share (the main holdings chart and the
// model allocation modal), so two charts of the same money never pick different ceilings.

// Nice y-axis ceiling + 4 evenly-spaced ticks that cover the largest balance.
const NICE_STEPS = [1000, 2000, 2500, 5000, 10000, 25000, 50000, 100000, 250000, 500000];
const TOP_STEP = NICE_STEPS[NICE_STEPS.length - 1];

export function niceAxis(maxBalance) {
  const target = maxBalance / 4;
  // Past the table, keep growing in $500K steps so the tallest bar is never clipped.
  const step = NICE_STEPS.find((s) => s >= target) || Math.ceil(target / TOP_STEP) * TOP_STEP;
  return { max: step * 4, ticks: [0, step, step * 2, step * 3, step * 4] };
}

export const fmtTick = (v) => {
  if (v === 0) return '$0';
  return v >= 1e6 ? `$${v / 1e6}M` : `$${v / 1000}K`;
};
